import React from "react";
import sanitizeHtml, {IOptions} from "sanitize-html";

interface Props {
	html: string;
	options?: IOptions;
}

const SanitizeHTML: React.FC<Props> = ({html, options}: Props) => {
	const sanitize = (dirty: string, options?: {}) => ({
		__html: sanitizeHtml(dirty, {...defaultOptions, ...options} as IOptions),
	});

	return <div dangerouslySetInnerHTML={sanitize(html, options)} />;
};

export default SanitizeHTML;

const defaultOptions: IOptions = {
	allowedTags: [
		"article",
		"h1",
		"h2",
		"h3",
		"h4",
		"h5",
		"h6",
		"section",
		"dd",
		"div",
		"dl",
		"dt",
		"li",
		"ol",
		"p",
		"ul",
		"code",
		"em",
		"i",
		"small",
		"span",
		"strong",
		"time",
		"caption",
		"table",
		"tbody",
		"td",
		"tfoot",
		"th",
		"thead",
		"tr",
		"b",
		"a"
	],
	allowedAttributes: {
		a: ["href", "name", "target"],
		img: ["src"],
	},
	selfClosing: ["img", "br", "hr", "link", "meta"],
	enforceHtmlBoundary: true,
	disallowedTagsMode: "escape",
};
